module.exports = __webpack_public_path__ + "static/img/手机端商品.c3997fbd.png";